import React from 'react'
import { Container } from '@components/Globals'
import { Column, Row } from '@components/Common'
import ArticleBody from '@components/ArticleBody'
import ArticleHeader from '@components/ArticleHeader'
import { ArticleFootnote } from '@components/Footnote'
import ArticlePDF from '@components/ArticlePDF'
import ArticleGrid from '@components/ArticleGrid'

const InsightsDetailMain = ({ customPdfUpload, articleGrid, ...rest }) => {
  // Determine if we should remove the bottom margin
  // Remove margin if there's an article grid with a "Light grey" background
  const shouldRemoveMargin =
    articleGrid && articleGrid.backgroundColor === 'Light grey'

  return (
    <Container fluid marginBottom={shouldRemoveMargin ? 0 : 40}>
      <Row>
        <Column className="block">
          <ArticleHeader {...rest} />
          <ArticleBody {...rest} />
          <ArticleFootnote {...rest} />
          {customPdfUpload && customPdfUpload.title && (
            <ArticlePDF
              linkToPdf={`https:${customPdfUpload?.file?.url}`}
              title={customPdfUpload?.title}
            />
          )}
        </Column>
      </Row>
      {articleGrid && (
        <Row>
          <Column>
            <ArticleGrid
              titleContent={articleGrid?.titleContent}
              columnLayout={articleGrid?.columnLayout}
              articles={articleGrid?.articles}
              ctaLink={articleGrid?.ctaLink}
              ctaTitle={articleGrid?.ctaTitle}
              topPadding={articleGrid?.topPadding}
              bottomPadding={articleGrid?.bottomPadding}
              backgroundColor={articleGrid?.backgroundColor}
            />
          </Column>
        </Row>
      )}
    </Container>
  )
}

InsightsDetailMain.propTypes = {}

export default InsightsDetailMain
